import { useEffect } from 'react';

import { useLocation, useNavigate, useParams, useSelector } from 'third-party';

import { loginUrl, tenantDashboardUrl, tenantListUrl } from 'constants/url';

import { useApp } from 'modules/app';

import { appSelectors } from 'selectors';

import { isUserAuthenticated } from 'utils/auth';

export const useAuth = () => {
  const isUserLogged = isUserAuthenticated();
  const { tenantId } = useParams();
  const isAppLoaded = useSelector(appSelectors.isAppLoaded);
  const selectedTenantId = useSelector(appSelectors.tenantId);
  const userId = useSelector(appSelectors.userId);
  const tenants = useSelector(appSelectors.tenants);
  const location = useLocation();

  const navigate = useNavigate();

  const { userInfo, refreshTokens, setAppIsLoaded } = useApp();

  useEffect(() => {
    if (!isUserLogged) {
      setAppIsLoaded(true);
      navigate(loginUrl());
      return;
    }

    if (isAppLoaded) {
      if (location.pathname === tenantListUrl() && tenants?.length) {
        navigate(tenantDashboardUrl(tenants[0].tenant.id));
      }
      return;
    }

    if (!userId) {
      userInfo().then(it => {
        if (it.error) {
          navigate(loginUrl());
          return;
        }

        // Refresh tokens after fetching user info
        refreshTokens();
      });
    }

    if (tenantId && tenantId != selectedTenantId) {
      return;
    }

    setAppIsLoaded(true);
  }, [
    isAppLoaded,
    userId,
    isUserLogged,
    navigate,
    tenantId,
    selectedTenantId,
    setAppIsLoaded,
    userInfo,
    location.pathname,
    tenants,
  ]);
};
